import { Cartesian3, Color } from 'cesium'
import _ from 'lodash'
import React, { useState } from 'react'
import {
	BillboardGraphics,
	Entity,
	EntityDescription,
	ImageryLayer,
	LabelGraphics,
	ScreenSpaceCameraController,
} from 'resium'
import drifter from '../../../assets/images/argos_icons/DRIFTER.png'
import clsLogo from '../../../assets/images/logo-cls-white.png'
import argosLogo from '../../../assets/images/logo_argos_bleu.png'
import satellite from '../../../assets/images/satellite.png'
import globe3dLastLoc from '../../../positions/globe3dLastLoc.json'
import globe3dSatelliteList from '../../../positions/globe3dSatelliteList.json'
import { imageryData } from '../../../utils/Imagery.utils'
import {
	DataType,
	ImageryDataType,
	SatelliteType,
} from '../../../utils/utils.types'
import ImageryPicker from '../ImageryPicker/ImageryPicker'
import { ArgosLogo, ClsLogo, MapViewer } from './Map.styles'

const Map = () => {
	const [imagerySelected, setImagerySelected] = useState<ImageryDataType>(
		imageryData[0],
	)

	const datas = globe3dLastLoc.response.data
	const satellites = globe3dSatelliteList.response.data

	return (
		<>
			<MapViewer
				full
				timeline={false}
				animation={false}
				homeButton={false}
				navigationHelpButton={false}
				sceneModePicker={false}
				geocoder={false}
				baseLayerPicker={false}
			>
				{/* Désactivation de l'inclinaison */}
				<ScreenSpaceCameraController enableTilt={false} />

				{/* Changement du fond de carte */}
				{imagerySelected.provider && (
					<ImageryLayer imageryProvider={imagerySelected.provider} />
				)}

				{/* c000 : longitude, c001: latitude, c002: type */}
				{datas.length !== 0 &&
					_.map(datas, (position: DataType, i: number) => (
						<Entity
							key={i + '_Data_' + position.c000}
							name={'Data'}
							position={Cartesian3.fromDegrees(
								Number(position.c000),
								Number(position.c001),
								0,
							)}
						>
							<BillboardGraphics image={drifter} scale={0.7} />
							<EntityDescription>
								<h4>Information</h4>
								<li>Longitude : {position.c000}</li>
								<li>Latitude : {position.c001}</li>
							</EntityDescription>
						</Entity>
					))}

				{/* c001 : longitude, c002: latitude, c000: nom */}
				{satellites.length !== 0 &&
					_.map(satellites, (position: SatelliteType, i: number) => (
						<Entity
							key={i + '_Satellite_' + position.c000}
							name={'Satellite'}
							position={Cartesian3.fromDegrees(
								Number(position.c001),
								Number(position.c002) * 10000,
								1000000.0,
							)}
						>
							<LabelGraphics
								scale={0.4}
								fillColor={Color.WHITE}
								text={
									'                              ' +
									position.c000
								}
							/>
							<BillboardGraphics image={satellite} scale={0.07} />
							<EntityDescription>
								<p>Satellite defilant LEO : {position.c000}</p>
							</EntityDescription>
						</Entity>
					))}
			</MapViewer>

			<ClsLogo src={clsLogo} alt={'clsLogo'} />
			<ArgosLogo src={argosLogo} alt={'argosLogo'} />

			<ImageryPicker
				imagerySelected={imagerySelected}
				setImagerySelected={setImagerySelected}
			/>
		</>
	)
}

export default Map
